import React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import RequestStatus from "src/model/RequestStatus";
import ProgramComponent from "./ProgramComponent"
import { GetProgramFeesResponse } from "src/model/ProgramFees"
import { GetProgramMetadataResponse } from "src/model/ProgramMetadata"
import MetricsUtil from "src/utils/MetricsUtil";
import ApplicationState from "src/model/ApplicationState";
import ErrorStatusComponent from "../common/ErrorStatusComponent";
import { setProgramFeesQueryStart } from "../../actions/ProgramFeesQueryAction";
import QueryProductInfo from "src/model/QueryProduct";
import { UpdateQueryProductResponse } from "src/model/QueryProduct";
import LoadingStatusComponent from "../common/LoadingStatusComponent";
import { defaultPrograms, getCurrencyUnitConfig, SELECT_YOUR_PROGRAM } from "src/config/Config";
import {GetSelectedProductResponse} from "src/model/ProductMatch";
import ProductDataValidator from "src/utils/ProductDataValidator";

interface StateProps {
    programMetadataRes: GetProgramMetadataResponse,
    programFeesRes: GetProgramFeesResponse,
    queryProductRes: UpdateQueryProductResponse,
    selectedProductRes: GetSelectedProductResponse,
}

const mapStateToProps = (state: ApplicationState): StateProps => ({
    programMetadataRes: state.programMetadataRes,
    programFeesRes: state.programFeesRes,
    queryProductRes: state.queryProductRes,
    selectedProductRes: state.selectedProductRes,
});

interface DispatchProps {
    readonly dispatchGetProgramFees: (countryCode: string, queryProduct: QueryProductInfo, programIdList: Array<string>) => void,
}

const mapDispatchToProps = (dispatch: Dispatch) => (
    bindActionCreators({
        dispatchGetProgramFees: setProgramFeesQueryStart
    }, dispatch)
);

interface OwnProps {
    readonly metricsUtil?: MetricsUtil
}

const connector = connect(mapStateToProps, mapDispatchToProps);

type Props = StateProps & OwnProps & DispatchProps & WithTranslation;

interface State {
}

export class ProgramComparisonComponent extends React.Component<Props, State> {
    private readonly metricsUtil: MetricsUtil;

    constructor(props: Props) {
        super(props);

        this.state = {
        };

        if (this.props.metricsUtil) {
            this.metricsUtil = this.props.metricsUtil;
        } else {
            this.metricsUtil = MetricsUtil.getDefaultMetricUtil();
        }

    }

    render() {
        const { t, queryProductRes, programMetadataRes, programFeesRes, selectedProductRes } = this.props;

        var queryProductExist: boolean = false;
        if (queryProductRes != null && queryProductRes.countryCode != null && queryProductRes.queryProduct != null) {
            queryProductExist = true;
        }

        let selectedProduct = selectedProductRes?.data?.selectedProduct;
        var selectedProductExistAndValid: boolean = false;
        if (selectedProduct && ProductDataValidator.isProductValid(selectedProduct)) {
            selectedProductExistAndValid = true;
        }

        var isShowProgramComparison: boolean = false;
        //When seller click select product, begin to show loading icon.
        if (queryProductExist || selectedProductExistAndValid) {
            isShowProgramComparison = true;
        }

        var hasError: boolean = false;
        if (programMetadataRes.requestStatus === RequestStatus.ERROR
            || programFeesRes.requestStatus === RequestStatus.ERROR) {
            hasError = true;
            if (this.metricsUtil) {
                this.metricsUtil.publishCounter("programComparisonData", "error");
            }
        }

        // This may cause loading when choosing program.
        //When programMetadata and programFees are ready, show the fee data.Otherwise, show loading icon.
        let isLoading = !(queryProductExist
            && (programMetadataRes && programMetadataRes.requestStatus === RequestStatus.SUCCESS)
            && (programFeesRes && programFeesRes.requestStatus === RequestStatus.SUCCESS));

        if (!isShowProgramComparison) {
            return (<></>);
        } else if (hasError) {
            return (<ErrorStatusComponent description={t('SC_FBA_Calc_calculateFeeFailedWarning')} className="alertStyle program-comparison-margin" />)
        } else if (isLoading) {
            return (<LoadingStatusComponent />);
        } else {
            return (
                <div className="program-comparison program-comparison-margin program-comparison-width">
                    <ProgramComponent metricsUtil={this.metricsUtil} initialProgram={defaultPrograms[0]} />
                    <ProgramComponent metricsUtil={this.metricsUtil} initialProgram={defaultPrograms[1]} />
                    <ProgramComponent metricsUtil={this.metricsUtil} initialProgram={SELECT_YOUR_PROGRAM} />
                </div>
            );
        }
    }
}

export default withTranslation()(connector(ProgramComparisonComponent));
